import { Suspense, useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { page } from 'analytics/frontend';
import GlobalLoader from 'components/GlobalLoader';
import Basics from 'pages/Basics';
import BenefitAmount from 'pages/BenefitAmount';
import BenefitPeriod from 'pages/BenefitPeriod';
import BloodPressure from 'pages/BloodPressure';
import Depression from 'pages/Depression';
import Diabetes from 'pages/Diabetes';
import HealthBasics from 'pages/HealthBasics';
import Occupation from 'pages/Occupation';
import PolicyFeatures from 'pages/PolicyFeatures';
import SleepApnea from 'pages/SleepApnea';
import WaitingPeriod from 'pages/WaitingPeriod';

import {
  SURVEY_BASICS_PATH,
  BENEFIT_AMOUNT_PATH,
  BENEFIT_PERIOD_PATH,
  OCCUPATION_PATH,
  POLICY_FEATURES_PATH,
  WAITING_PERIOD_PATH,
  HEALTH_BASICS_PATH,
  BLOOD_PRESSURE_PATH,
  DEPRESSION_PATH,
  DIABETES_PATH,
  SLEEP_APNEA_PATH,
} from './paths';
import styles from './styles';
import { RoutesProps } from './types';

const useStyles = createUseStyles(styles);

export default function Routes({ loading }: RoutesProps) {
  const classes = useStyles();
  const location = useLocation();

  useEffect(() => {
    if (!loading) {
      page();
    }
  }, [location, loading]);

  return (
    <main className={classes.mainContent}>
      {loading ? (
        <GlobalLoader />
      ) : (
        <Suspense fallback={<GlobalLoader />}>
          <Switch>
            {/* Survey Routes */}
            <Route path={SURVEY_BASICS_PATH} component={Basics} />
            <Route path={OCCUPATION_PATH} component={Occupation} />
            <Route path={BENEFIT_AMOUNT_PATH} component={BenefitAmount} />
            <Route path={WAITING_PERIOD_PATH} component={WaitingPeriod} />
            <Route path={BENEFIT_PERIOD_PATH} component={BenefitPeriod} />
            <Route path={POLICY_FEATURES_PATH} component={PolicyFeatures} />
            {/* Health Routes */}
            <Route path={HEALTH_BASICS_PATH} component={HealthBasics} />
            <Route path={BLOOD_PRESSURE_PATH} component={BloodPressure} />
            <Route path={DEPRESSION_PATH} component={Depression} />
            <Route path={DIABETES_PATH} component={Diabetes} />
            <Route path={SLEEP_APNEA_PATH} component={SleepApnea} />
            <Redirect from="*" to={SURVEY_BASICS_PATH} />
          </Switch>
        </Suspense>
      )}
    </main>
  );
}
